import { Signals } from "@/Imports";
import Facade from "@/Facade";
import ReelsConfig from "@/config/ReelsConfig";
import GameColumnManager from "@/managers/field/GameColumnManager";
import gsap from "gsap";

export default class GameFieldManager {
  constructor(dataField) {
    Signals.startSpin.add(this.takeOut, this);
    Signals.cancelSpin.add(this.stop, this);
    Signals.stopSpin.add(this.stop, this);
    // Signals.graphicsCreated.add(this.init, this)

    Signals.columnClearFeelOnDown.add(this.onColumnCleared, this);
    //      Signals.startAllAnimations.add(this.onStartAllAnimations, this)
    // Signals.startAnimation.add(this.startSingleAnimation, this)
    // Signals.hideCountingUpWinnings.add( this.showAllSymbols, this)

    this.dataField = dataField;

    this.updateData();
    this.init();
  }

  init() {
    this.lastStoppedReelIndex = 0;
    this.delayStopColumn = 150; //150
    this.stopDelays = ReelsConfig.STOP_REEL_DELAY.concat();
    this.columns = this.createColumns();

    // список флагов остановился или нет symbol
    this.listStopColumns = this.createStopList();
  }

  createColumns = () => {
    const columns = [];
    for (let i = 0; i < ReelsConfig.TOTAL_REELS; i++) {
      columns.push(this.createColumn(i));
    }
    return columns;
  };

  createColumn(i) {
    return new GameColumnManager(i, this.dataField, ReelsConfig);
  }

  createStopList = () => {
    const stopList = [];
    for (let i = 0; i < ReelsConfig.TOTAL_REELS; i++) {
      stopList.push(false);
    }
    return stopList;
  };

  updateData() {
    const initData = Facade.model.gridStages[0]; //reelsData
    const multipliers = Facade.model.multipliers;
    this.dataField.initSymbols(initData, multipliers);
  }

  takeOut() {
    console.log("GMF : takeOut");
    this.stoped = false;
    this.delayStopColumn = 0.09; /// 0.15//150
    this.startCounter = ReelsConfig.TOTAL_REELS;
    // this.showAllSymbols()
    this.stopData = null;
    Facade.iFastStop = false;
    // Signals.spinBtnPressed.addOnce(this.onImmediateStop, this)
    Signals.spinBtnPressed.addOnce(this.onImmediateStop, this);

    const takeOutColumn = (index) => {
      this.columns[index].takeOut(); //start ()
      if (index + 1 < this.columns.length) {
        setTimeout(() => takeOutColumn(index + 1), 50); // ReelsConfig.START_REEL_DELAY[index + 1])
      }
    };

    takeOutColumn(0);
  }

  showAllSymbols() {
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].showAllSymbols();
    }
  }

  onColumnCleared(index) {
    this.startCounter--;
    if (this.startCounter === 0 && this.stopData && !this.stoped) {
      this.stop(this.stopData);
    }
  }

  stop(
    data = Facade.model.gridStages,
    combinations = Facade.model.combinations,
    freeSymbolsPosition = Facade.model.freeSymbolsPosition
  ) {
    console.log("STOP SYMB");
    this.animateNewStageFalling(data, combinations, freeSymbolsPosition);
    ///this.animateNewStageFalling(Facade.model.gridStages, Facade.model.combinations,
    // Facade.model.freeSymbolsPosition)

    // this.stopData = data
    // this.multiplierData = multiplierData
    // if(this.startCounter === 0) {
    //     this.stoped = true
    //     this.stopReelCounter = this.columns.length
    //     this.listStopColumns.map(flag => false)
    //     this.stopColumn (0, data)
    // }
  }

  _isFastSpin() {
    return false; //EntryPoint.GameSettings.quickSpin || EntryPoint.GameModel.stopClicked;
  }

  stopColumn = (index, data) => {
    // this.columns.forEach((column, ind) => column.showResult(data[ind]))
    this.columns[index].showResult(data[index]);
    this.lastStoppedReelIndex = index;
    if (index + 1 < this.columns.length) {
      let delay = this.stopDelays[index + 1];
      if (
        (Facade.iFastStop || Facade.isQuickSpin) &&
        this.stopDelays[index + 1] === ReelsConfig.STOP_REEL_DELAY[index + 1]
      ) {
        delay = 0;
      }
      this.currentReelStopTimeout = setTimeout(
        () => this.stopColumn(index + 1, data),
        this.delayStopColumn
      );
    }
  };

  onImmediateStop = () => {
    console.log("onImmediateStop", this.index);

    Facade.iFastStop = true;
    if (!this.stoped) {
      this.columns.forEach((column) => column.faster());
      this.delayStopColumn = 0.04; //50
    }
    if (this.stopData && this.stoped) {
      clearTimeout(this.currentReelStopTimeout);
      for (let i = 0; i < this.lastStoppedReelIndex + 1; i++) {
        this.columns[i].stop3(this.stopData[i]);
      }
      for (
        let i = this.lastStoppedReelIndex + 1;
        i < this.columns.length;
        i++
      ) {
        let isImmediate =
          this.stopDelays[i] == ReelsConfig.STOP_REEL_DELAY[i] ? true : false;
        if (isImmediate) {
          this.columns[i].stop(this.stopData[i]);
        } else {
          setTimeout(
            () => this.columns[i].stop(this.stopData[i]),
            50 * (i - this.lastStoppedReelIndex)
          );
        }
      }
    }
  };

  finishFeelOnField = () => {
    Signals.reelsStopComplete.dispatch();
    this.stopDelays = ReelsConfig.STOP_REEL_DELAY.concat();
    this.startCounter = ReelsConfig.TOTAL_REELS;
    this.stopData = null;
  };

  onFinishFeelOnField = (reelIndex) => {
    if (reelIndex + 1 <= this.stopDelays.length - 1) {
      Signals.reelStopped.dispatch({ reelIndex: reelIndex + 1 });
    }
    this.listStopColumns[reelIndex] = true;
    // this.stopReelCounter--
    Signals.reelsStopCompleteReel.dispatch({ reelIndex: reelIndex });
    // if(this.stopReelCounter === 0) {
    if (this.listStopColumns.every((element) => element === true)) {
      Signals.reelsStopComplete.dispatch();
      this.stopDelays = ReelsConfig.STOP_REEL_DELAY.concat();
      this.startCounter = ReelsConfig.TOTAL_REELS;
      this.stopData = null;
    }
  };

  onStartAllAnimations(totalList) {
    for (let i = 0; i < totalList.length; i++) {
      let data = totalList[i];
      let j = 0;
      //    for (let j = 0; j < data.length; j ++) {
      const path = data[j][0].paycluster.cluster_symbols;
      path.map((cell) => this.columns[cell[0]].showWinAnimation(cell[1]));

      //  }
    }
  }

  onWinAnimationEnd() {
    this._winView.hide();
    this._fieldBlocker.visible = false;

    //     GlobalDispatcher.dispatch(eEventTypes.EET_SPIN_NEXT_STAGE);
    // } else {
    // GlobalDispatcher.dispatch(eEventTypes.EET_REELS_STOPPED);
    //

    // EntryPoint.GameModel.nextStage();
  }

  async animateNewStageFalling(
    gridStages,
    combinationsStage,
    freeSymbolsPosition
  ) {
    // заполнить всё поле изначально

    const getIndexColumnAnticipation = (freeSymbolsPosition) => {
      const lessOrEqualTwo = Facade.model._bonus.freebetCount === 0;
      const rawFreebets = Facade.model._bonus.freebetsPosition;
      const rawFreebetsTwoTotal = rawFreebets && rawFreebets.length >= 2;
      const rawFreebetsTwoFirstLine =
          rawFreebets && rawFreebets[0] && rawFreebets[0].length >= 2;

      const rawMatches =
        lessOrEqualTwo && (rawFreebetsTwoFirstLine || rawFreebetsTwoTotal);

      let index = 5;

      const twoTotal = freeSymbolsPosition.length >= 2;
      const twoFirstLine =
        freeSymbolsPosition[0] && freeSymbolsPosition[0].length >= 2;

      if (twoTotal || twoFirstLine || rawMatches || rawFreebetsTwoFirstLine) {
        index = rawFreebets[rawFreebets.length - 1]?.[1]?.[0] || 5;
      }
      return index;
    };

    const feelOnField = async (stage) => {
      const feelOnColumn = (column, data, anticipation) => {
        return new Promise((resolve) => {
          let timeDown = 0.03; //anticipation ? 0.6 : 0.03
          if (Facade.status === 911) {
            timeDown = 0.0;
            this.delayStopColumn = 0;
          }
          column.showResult(data, anticipation, timeDown);
          // Facade.soundManager.play('tob_bon_ra_disappear', 1, false, 'default')
          gsap.delayedCall(this.delayStopColumn + timeDown, () => {
            // gsap.delayedCall(0.01, () => {
            resolve();
          });
        });
      };
      this.listStopColumns.map((flag) => false);
      const indexColumnAnticipation =
        getIndexColumnAnticipation(freeSymbolsPosition);

      for await (let column of this.columns) {
        const showAnticipation = false; //column.index > indexColumnAnticipation;
        await feelOnColumn(column, stage[column.index], showAnticipation);
      }
    };

    const pause = async (time) => {
      return new Promise((resolve) => {
        gsap.delayedCall(time, () => {
          resolve();
        });
      });
    };

    const feelOnFieldCombination = async (stage, combinations) => {
      const feelOnColumn = (column, data, anticipation) => {
        return new Promise((resolve) => {
          let timeDown = anticipation ? 0.6 : 0.5;
          column.showResult2(data, anticipation, timeDown, 0.2);
          // Facade.soundManager.play('tob_bon_ra_disappear', 1, false, 'default')
          gsap.delayedCall(timeDown, () => {
            resolve();
          });
        });
      };
      this.listStopColumns.map((flag) => false);

      for (let combination of combinations) {
        let listIndexColumn = combination.combo.reduce((prev, currentCell) => {
          if (prev.includes(currentCell.x)) {
            return prev;
          }
          return [...prev, currentCell.x];
        }, []);
        for (let index of listIndexColumn) {
          const indexColumnAnticipation =
            getIndexColumnAnticipation(freeSymbolsPosition);
          const showAnticipation = false; // index > indexColumnAnticipation;
          // await feelOnColumn(this.columns[index], stage[index], showAnticipation)
          feelOnColumn(this.columns[index], stage[index], showAnticipation);
        }
      }
    };

    const showWinStage = (combinations) => {
      console.log(" -$ -   showWinStage ", combinations);
      return new Promise((resolve) => {
        // for (let i = 0; i < totalList.length; i ++) {
        //     let data = totalList[ i ]
        //     let j = 0;
        //     //    for (let j = 0; j < data.length; j ++) {
        //     const path = data[ j ][0].paycluster.cluster_symbols
        //     path.map(cell => this.columns[cell[0]].showWinAnimation(cell[1]))
        //
        //     //  }
        // }
        //  combination.winAmount
        if (combinations && combinations.length === 0) {
          resolve();
          return;
        }
        this.columns.forEach((column) => {
          column.darken();
        });
        for (let combination of combinations) {
          combination.combo.forEach((cell) => {
            this.columns[cell.x].showWinAnimation(cell.y);
          });
        }
        Signals.playWinLevel.dispatch({
          winlevel: this.getWinLevel(
            Facade.model._winCurrency,
            Facade.model._totalBetNumber
          ),
        });

        //find mp
        // this.columns[cell.x].showWinAnimation(cell.y)
        gsap.delayedCall(1.2, () => {
          resolve();
        });
      });
    };

    const showScatterWin = (freeSymbolsPosition) => {
      Signals.stopAnticipation.dispatch();
      //console.log(' -$ -   showScatterWin ', freeSymbolsPosition)
      return new Promise((resolve) => {
        if (freeSymbolsPosition && freeSymbolsPosition.length === 0) {
          if (Facade.model.isShowAnimationMultipliers) {
            Signals.bonusMultiplierFly.dispatch();
          }
          //Signals.setWin.dispatch(Facade.model.winCurrency)
          resolve();
          return;
        }
        this.columns.forEach((column) => {
          column.darken();
        });
        // play Sound Animation
        Signals.playMultiplierTrigger.dispatch();
        freeSymbolsPosition.forEach((cell) => {
          this.columns[cell[0]].showWinAnimation(cell[1]);
        });
        Signals.startCountingUpInterimWinnings.dispatch({
          winnings: Facade.model.winBonusAmountCurrency,
          position: { x: 3, y: 3 },
          upper: Facade.model.isMultipliers,
          bonusFly: Facade.model.isShowAnimationMultipliers,
          curentlySum: Facade.model.winTriggeredAmountCurrency, //winBonusAmountCurrency
        });
        // TODO: sumWinAmount   scatter + all     or Nothing
        //  Signals.setWin.dispatch(sumWinAmount)
        // if (Facade.model.isShowAnimationMultipliers ) {
        //     Signals.bonusMultiplierFly.dispatch()
        // }
        gsap.delayedCall(1.2, () => {
          this.columns.forEach((column) => {
            column.brighten();
          });
          resolve();
        });
      });
    };
    const disappearCells = (combinations, indexCurrentStage) => {
      Signals.stopAnticipation.dispatch();
      return new Promise((resolve) => {
        for (let combination of combinations) {
          combination.combo.forEach((cell) => {
            this.columns[cell.x].disappear(cell.y);
          });
        }
        gsap.delayedCall(0.2, () => {
          this.columns.forEach((column) => {
            column.brighten();
          });
        });
        gsap.delayedCall(0.3, () => {
          let sumWinAmount = Facade.model.scoreUpperWinToDesk(
            indexCurrentStage - 1
          );
          for (let combination of combinations) {
            sumWinAmount += combination.winAmount;
            //console.log('  MC :  disappearCells ',sumWinAmount, combination.winAmount)
            let xx = 0;
            let yy = 0;
            combination.combo.forEach((cell) => {
              xx += cell.x;
              yy += cell.y;
            });
            Signals.playSymbolRemove.dispatch();
            //Signals.playSymbolDrop.dispatch();
            Signals.startCountingUpInterimWinnings.dispatch({
              winnings: combination.winAmount,
              position: {
                x: Math.ceil(xx / combination.combo.length),
                y: Math.ceil(yy / combination.combo.length),
              },
              upper: Facade.model.isMultipliers,
              bonusFly: false,
              curentlySum: sumWinAmount,
            });
            //   Signals.setWin.dispatch(sumWinAmount)
          }

          // if  (Facade.model.isShowAnimationMultipliers) {
          //     Signals.bonusMultiplierShowTextWinScore.dispatch({
          //         //TODO : count in Model
          //         sumWinAmount: sumWinAmount
          //     })
          // }
          resolve();
        });
      });
    };

    const changeStage = () => {
      console.log(" -$ -   changeStage ");
      return new Promise((resolve) => {
        indexCurrentStage++;
        // currentStage = gridStages[indexCurrentStage];
        // nextStage = gridStages[indexCurrentStage + 1];
        // combination = combinations[indexCurrentStage];
        // resolve()
        gsap.delayedCall(6, () => {
          resolve();
        });
      });
    };
    const removeSymbols = (currentStage, nextStage, combinations) => {
      return new Promise((resolve) => {
        const itemsToRemoveList = [];
        for (let combination of combinations) {
          combination.combo.forEach((cell) => {
            itemsToRemoveList.push({ x: cell.x, y: cell.y });
          });
        }
        itemsToRemoveList.sort((a, b) => {
          if (a.x > b.x) {
            return 1;
          }
          if (a.x < b.x) {
            return -1;
          }
          if (a.x === b.x && a.y > b.y) {
            return 1;
          }
          if (a.x === b.x && a.y < b.y) {
            return -1;
          }
          return 0;
        });
        //console.log(' itemsToRemoveList ', itemsToRemoveList)
        let currentX = -1;
        let maximumIndexDelete = -1;
        for (let cellRemove of itemsToRemoveList) {
          if (currentX !== cellRemove.x) {
            maximumIndexDelete = -1;
            nextStage[cellRemove.x].forEach((cellStage) => {
              if (cellStage.new) {
                //} && currentStage[cellRemove.x][cellRemove.y].destroyed){
                maximumIndexDelete++;
              }
            });
          }
          if (maximumIndexDelete < 0) maximumIndexDelete = 0;
          // console.log('@      ',maximumIndexDelete)
          currentX = cellRemove.x;
          const dataNextCell = nextStage[cellRemove.x][maximumIndexDelete];
          cellRemove.showSymbol = dataNextCell;
          //this.columns[cellRemove.x].removeSymbol(cellRemove.y, dataNextCell.id, dataNextCell.multiplier)
          //console.log('@@@@  ',cellRemove.x, cellRemove.y, dataNextCell.id, dataNextCell.new)
          //listStartY.push({x: cell.x, y: cell.y, yShow: maximumIndexDelete})
          maximumIndexDelete--;
        }

        for (let i = 0; i < itemsToRemoveList.length; i++) {
          const cell = itemsToRemoveList[i];
          //  if (cell.yShow > -1){
          this.columns[cell.x].removeSymbol(
            cell.y,
            cell.showSymbol.id,
            cell.showSymbol.multiplier
          );

          //}
        }

        gsap.delayedCall(0.1, () => {
          Signals.playSymbolRemove.dispatch();
          resolve();
        });
      });
    };

    try {
      console.log(Facade.status);
      let indexCurrentStage = 0;
      let combinations = combinationsStage[indexCurrentStage];
      Signals.bonusMultiplierChange.dispatch({ count: 0 });
      await feelOnField(gridStages[indexCurrentStage]);
      const timePause =
          Facade.model.bonus.multipliers && Facade.model.bonus.multipliers[indexCurrentStage] > 1 ? 0.7 : 0.3;
      await pause(timePause);
      Signals.bonusMultiplierChange.dispatch({
        count: Facade.model.bonus.multipliers ? Facade.model.bonus.multipliers[indexCurrentStage]: 0,
      });
      // if (combinations) {
      await pause(0.6);
      //}
      // for (let stage of gridStages) {
      if (Facade.status !== 911) {
        while (combinations) {
          let currentStage = gridStages[indexCurrentStage];
          let nextStage = gridStages[indexCurrentStage + 1];
          Signals.bonusMultiplierChange.dispatch({
            count: Facade.model.bonus.multipliers[indexCurrentStage],
          });
          Signals.playSymbolCascade.dispatch();
          console.log(
            `%c stage : ${indexCurrentStage}`,
            "color:white;background: red"
          );
          console.log(" -$ -   showWinStage ", indexCurrentStage);

          await showWinStage(combinations);
          await disappearCells(combinations, indexCurrentStage);
          await removeSymbols(currentStage, nextStage, combinations);
          await feelOnFieldCombination(nextStage, combinations);
          //   await changeStage()
          indexCurrentStage++;
          combinations = combinationsStage[indexCurrentStage];
          //   if (Facade.model.bonus.multipliers[indexCurrentStage] > 1 || combinations){
          await pause(0.8);
          // }
        }

        Signals.bonusMultiplierChange.dispatch({
          count: Facade.model.bonus.multipliers[indexCurrentStage],
        });
        await showScatterWin(freeSymbolsPosition);
        // if (Facade.model.isShowAnimationMultipliers ) {
        //     Signals.bonusMultiplierFly.dispatch()
        // }
        if (
          Facade.model.bonus.multipliers[indexCurrentStage] > 1 &&
          Facade.model.winCurrency > 0
        ) {
          await pause(2);
        }
      }
      this.finishFeelOnField();
      // Signals.setWin.dispatch(Facade.model.winCurrency)
    } catch (err) {
      console.log("err", err);
    }
  }

  getWinLevel(winAmount, betAmount) {
    const mlt = winAmount / betAmount;
    let level = 1;
    if (mlt > 1 && mlt <= 2) {
      level = 2;
    }
    if (mlt > 2 && mlt <= 5) {
      level = 3;
    }
    if (mlt > 5 && mlt <= 10) {
      level = 4;
    }
    if (mlt > 10) {
      level = 5;
    }
    return level;
  }
}
